// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91e89b22","239":"01540830","455":"ca1a188b"}[chunkId] + ".chunk.js";
};